import { stateCity } from '../../modules/select';
import { recaptchaUpdater } from '../../modules/recaptcha';

export const profilesState = () => {
  stateCity();
  recaptchaUpdater('profile');
};
